// extracted by mini-css-extract-plugin
export default {"title":"I--z","warning":"J--z","sizeOptionsLegendText":"K--z"};